// Option pills for product forms that live outside the product template (e.g. homepage featured product).
// Maps the checked option values to a variant from embedded JSON and syncs the form's input[name="id"].
class SVariantOptions extends HTMLElement {
  #ac;
  #variants = [];
  #announceRafId = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const data = this.querySelector('script[type="application/json"][data-variants]');
    try {
      this.#variants = data ? JSON.parse(data.textContent) : [];
    } catch {
      this.#variants = [];
    }
    this.addEventListener('change', () => this.#update(true), { signal: this.#ac.signal });
    this.#update(false);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#announceRafId);
  }

  #fieldsets() {
    return [...this.querySelectorAll('fieldset[data-option-index]')];
  }

  #selected() {
    return this.#fieldsets().map((fieldset) => fieldset.querySelector('input:checked')?.value ?? null);
  }

  #update(announce) {
    const selected = this.#selected();
    const variant = this.#variants.find((v) => v.options.every((value, i) => value === selected[i]));
    const root = this.closest('[data-variant-root]') || this;
    const idInput = root.querySelector('input[name="id"]');
    const button = root.querySelector('[data-add-button]');
    const label = button?.querySelector('[data-add-label]');
    const price = root.querySelector('[data-variant-price]');

    if (idInput && variant) idInput.value = variant.id;
    if (price && variant) price.textContent = variant.price;

    for (const fieldset of this.#fieldsets()) {
      const index = Number(fieldset.dataset.optionIndex);
      const current = fieldset.querySelector('[data-selected-value]');
      if (current) current.textContent = selected[index] ?? '';
      for (const input of fieldset.querySelectorAll('input')) {
        const available = this.#variants.some(
          (v) => v.available && v.options[index] === input.value && v.options.every((value, i) => i === index || value === selected[i])
        );
        input.toggleAttribute('data-unavailable', !available);
      }
    }

    if (button) {
      const canBuy = Boolean(variant && variant.available);
      button.disabled = !canBuy;
      if (label) {
        label.textContent = canBuy ? button.dataset.addText : variant ? button.dataset.soldOutText : button.dataset.unavailableText;
      }
    }

    if (announce && variant) {
      const announcer = root.querySelector('[data-variant-status]');
      if (announcer) {
        cancelAnimationFrame(this.#announceRafId);
        announcer.textContent = '';
        this.#announceRafId = requestAnimationFrame(() => {
          announcer.textContent = `${variant.title}, ${variant.price}${variant.available ? '' : `, ${button?.dataset.soldOutText ?? ''}`}`;
        });
      }
    }
  }
}

if (!customElements.get('s-variant-options')) customElements.define('s-variant-options', SVariantOptions);
